import React from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import FalconCloseButton from "components/common/FalconCloseButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faTimes } from "@fortawesome/free-solid-svg-icons";
const FormData = ({
    show,
    handleClose,
    formAttribute,
    handleChange,
    handleSubmit,
    isLoading,
    validate
}) => {
    const { title, data } = formAttribute;
    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Header className="bg-card-gradient light border-bottom-0">
                <Modal.Title className="text-white">{title}</Modal.Title>
                <FalconCloseButton onClick={handleClose} variant="white"/>
            </Modal.Header>
            <Modal.Body>
                <Form noValidate validated={validate} onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="formGroupKode">
                        <Form.Label>Kode</Form.Label>
                        <Form.Control 
                            type="text" 
                            value={data?.vckode} 
                            onChange={(event) => handleChange(event)} 
                            name="vckode" 
                            placeholder="Kode"
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            Kode tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGroupNama">
                        <Form.Label>Nama</Form.Label>
                        <Form.Control
                            type="text"
                            value={data?.vcnama}
                            onChange={(event) => handleChange(event)}
                            name="vcnama"
                            placeholder="Nama" 
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            Nama tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGroupAlamat">
                        <Form.Label>Alamat</Form.Label>
                        <Form.Control
                            type="text"
                            value={data?.vcalamat}
                            onChange={(event) => handleChange(event)}
                            name="vcalamat"
                            placeholder="Alamat" 
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            Alamat tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGroupGender">
                        <Form.Label>Jenjang Sekolah</Form.Label>
                        <Form.Select value={data?.intjenjangsekolah} onChange={(event) => handleChange(event)} name="intjenjangsekolah" required>
                            <option value=''>Pilih Jenjang Sekolah</option>
                            <option value={2}>SD</option>
                            <option value={3}>SMP</option>
                            <option value={4}>SMA / SMK</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                            Jenjang Sekolah tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>
                    
                    <Button variant="secondary" onClick={handleClose} disabled={isLoading}>
                        <FontAwesomeIcon icon={faTimes} className="me-2" /> Tutup
                    </Button>
                    <Button disabled={isLoading} type="submit" className="float-end">
                        {isLoading ? (<>
                            <Spinner
                                as="span"
                                animation="grow"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            Loading...
                        </>
                        ) : (<>
                            <FontAwesomeIcon icon={faSave} className="me-2" />
                            Simpan
                        </>) }
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

FormData.propTypes = {}

export default FormData;